import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonElafronKentimata';
const args = {};

export class OligonElafronKentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
